<template>
  <div>
    <vue-plotly
      :data="chartData"
      :options="chartOptions"
      :layout="layout"
    ></vue-plotly>
  </div>
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";
import OZG_MILESTONE_STATES from "../../store/const";
export default {
  name: "OZGTimelineGanttChart",
  props: ["serviceId"],
  components: { VuePlotly },
  data() {
    var showlegend = true;
    if (this.$props.showLegend) {
      showlegend = this.$props.showLegend;
    }
    return {
      aggregateOzgTimeline: null,
      showlegend: showlegend,
      layout: {
        height: 300,
        yaxis: {
          showgrid: false,
          zeroline: false,
          showline: false,
          showticklabels: false
        },
        legend: { orientation: "h" }
      },

      chartData: [],
      chartOptions: {
        sort: false
      }
    };
  },

  watch: {
    aggregateGanttChart: function(newVal) {
      this.chartData = [];
      for (var x in newVal) {
        console.log(OZG_MILESTONE_STATES);
        this.chartData.push({
          x: [newVal[x].start, newVal[x].end],
          y: [x + 1, x + 1],
          line: { width: 20 },
          type: "scatter",
          mode: "lines",
          text: [
            {
              name: OZG_MILESTONE_STATES.OZG_MILESTONE_STATES[newVal[x].name],
              days: newVal[x].days,
              date: newVal[x].start
            },
            {
              name: OZG_MILESTONE_STATES.OZG_MILESTONE_STATES[newVal[x].name],
              days: newVal[x].days,
              date: newVal[x].end
            }
          ],
          name: OZG_MILESTONE_STATES.OZG_MILESTONE_STATES[newVal[x].name],
          hovertemplate: "%{text.date} - %{text.name} (%{text.days} Tage)"
        });
      }
    }
  },
  apollo: {
    $client: "ozgClient",
    aggregateGanttChart: {
      query() {
        return require("../../graphql/aggregateGanttChart.gql");
      },
      variables: function() {
        console.log(this.$props.serviceId);
        return {
          serviceId: this.$props.serviceId
        };
      }
    }
  }
};
</script>

<style scoped></style>
